export default __webpack_public_path__ + "static/30-sitzer-1-bdf160cecc7985304dfda1cc86c2d052.jpg";